<template>
    <div class="elec_fee_accounts">
        <div class="form-box">
            <el-form
                :model="formModel"
                label-width="80px"
                inline
                label-position="left"
                class="leader-style-form"
            >
                <el-form-item label="月份">
                    <el-date-picker
                        type="month"
                        placeholder="选择日期"
                        v-model="formModel.date"
                        style="width: 100%;"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item style="float: right">
                    <el-button>查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-wrap" style="height: 90%;">
            <el-table class="leader-style-table" :data="tableData">
                <el-table-column width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="月份"
                    align="center"
                    property="p1"
                ></el-table-column>
                <el-table-column
                    label="光伏发电量(kWh)"
                    align="center"
                    property="p2"
                ></el-table-column>
                <el-table-column
                    label="光伏消纳量(kWh)"
                    align="center"
                    property="p3"
                ></el-table-column>
                <el-table-column
                    label="消纳率"
                    align="center"
                    property="p4"
                ></el-table-column>
                <el-table-column
                    label="结算电费(元)"
                    align="center"
                    property="p5"
                ></el-table-column>
                <el-table-column
                    label="补正金额(元)"
                    align="center"
                    property="p6"
                ></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" class="leader-button">
                            <span class="inner-text">查看</span>
                        </el-button>
                        <el-button type="text" class="leader-button">
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button type="text" class="leader-button">
                            <span class="inner-text">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                class="leader-style-pagination"
                :paginationData="paginationData"
            ></pagination>
        </div>
    </div>
</template>
<script>
import pagination from "@/comon/components/pagination.vue";
export default {
    components: {
        pagination
    },
    data() {
        return {
            formModel: {
                date: "" //缺陷发现日期
            },
            tableData: [
                {
                    p1: "2023-01",
                    p2: "52154",
                    p3: "50000",
                    p4: "90%",
                    p5: "50000",
                    p6: "-503"
                }
            ], //表格数据
            paginationData: {
                pageNum: "1",
                pageSize: "1",
                totalNum: "1"
            }
        };
    }
};
</script>
<style lang="scss">
.elec_fee_accounts {
    width: 100%;
    height: 100%;
    padding: 0 40px;
    box-sizing: border-box;
}
</style>
